import { ReactElement } from "react";
import styles from "../ActivityFeedSpaces.module.less";
import { ExpandedStackBar } from "./ExpandedStackBar";

export type ExpandedStackFooterActivityFeedItemProps = {
	stackId: string;
	shouldRenderButtons: boolean;
	canStackBeDeletedByUser: boolean;
	onCollapse(): void;
	onDelete(): void;
	onMute(): void;
};

export const ExpandedStackFooterActivityFeedItem = (props: ExpandedStackFooterActivityFeedItemProps): ReactElement => {
	const {
		stackId,
		shouldRenderButtons,
		canStackBeDeletedByUser,
		onCollapse,
		onDelete,
		onMute
	} = props;

	return (
		<div className={styles.expandedStackFooterItem}>
			{shouldRenderButtons && (
				<ExpandedStackBar
					stackId={stackId}
					title=""
					canStackBeDeletedByUser={canStackBeDeletedByUser}
					onCollapse={onCollapse}
					onDelete={onDelete}
					onMute={onMute}
				/>
			)}
		</div>
	);
};

ExpandedStackFooterActivityFeedItem.displayName = "ExpandedStackFooterActivityFeedItem";